/* src/app/location-users/location-user-grid/location-user-grid.component.scss */
.no-locations-message {
  padding-top: 58px;
  font-style: italic;
}
.users-search {
  width: 100%;
  min-height: 80px;
}
.location-user-grid {
  width: 100%;
  overflow-x: clip;
}
.location-user-grid .scrollbar {
  width: 100%;
  overflow-x: auto;
  position: sticky;
  bottom: 0;
  z-index: 3;
}
.location-user-grid .user-header-table {
  visibility: hidden;
  height: 0px;
  max-height: 0px;
  overflow: hidden;
}
.location-user-grid .location {
  width: 332px;
  min-width: 332px;
}
.location-user-grid table {
  border-collapse: separate;
  border-spacing: 0;
  position: relative;
}
.location-user-grid table thead th {
  border: 1px solid #757575;
  border-left: none;
  padding: 3px;
  position: sticky;
  top: 0;
  z-index: 1;
  background: white;
  white-space: nowrap;
  max-width: 282px;
}
.location-user-grid table thead th:first-child {
  position: sticky;
  left: 0;
  z-index: 2;
  border: none;
  border-bottom: 1px solid #757575;
  border-right: 1px solid #757575;
}
.location-user-grid table thead td:first-child {
  position: sticky;
  left: 0;
  z-index: 2;
  border: none;
  border-bottom: 1px solid #757575;
}
.location-user-grid table tbody tr th {
  border-bottom: 1px solid #757575;
  border-left: 1px solid #757575;
  border-right: 1px solid #757575;
  position: sticky;
  left: 0;
  background: white;
  z-index: 1;
  white-space: nowrap;
}
.location-user-grid table tbody tr:last-child th {
  border-bottom: 1px solid #757575;
}
.location-user-grid table tbody tr td {
  border-right: 1px solid #757575;
  border-bottom: 1px solid #757575;
}
.location-user-grid table tbody tr td.user-info {
  height: 75px;
  width: 262px;
}
.server-failure {
  width: 322px;
  display: flex;
}
.server-failure .icon-container {
  position: relative;
  width: 24px;
  min-width: 24px;
  padding-right: 2px;
}
.server-failure .icon-container .exclamation-icon:before {
  font-family: upsicons, fantasy !important;
  color: #C91913;
  content: "\e638" !important;
  position: absolute;
  font-size: 18px;
  left: 0;
  top: 0.5rem;
}
.server-failure .error-text {
  color: #C91913;
  font-weight: normal;
  white-space: normal;
}
@media (min-width: 768px) {
  .location-user-grid .location {
    left: 22px;
  }
  .location-user-grid table thead th:first-child {
    left: 22px;
  }
  .location-user-grid table tbody tr th {
    left: 22px;
  }
}
@media (min-width: 1880px) {
  .location-user-grid .location {
    left: 152px;
  }
  .location-user-grid table thead th:first-child {
    left: 152px;
  }
  .location-user-grid table tbody tr th {
    left: 152px;
  }
}
/*# sourceMappingURL=location-user-grid.component.css.map */
